import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { TEST_IDS, URLS } from '../../utils/constants';
import { handleError } from '../../utils/errorHandling';
import { useCancellationMutation } from './useCancellationMutation';
import { useCancellationQuery } from './useCancellationQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const linkElement = {
  Link: UILink
};
const linkOptions = {
  href: URLS.KBCancelSubscription
};
export function CancellationModal({
  objectId,
  actions
}) {
  var _submitData$response$, _submitData$response;
  const {
    close
  } = actions;
  const {
    data: queryData,
    loading: queryLoading
  } = useCancellationQuery(objectId);
  const [onSubmit, {
    data: submitData,
    loading: submitLoading,
    error: submitError
  }] = useCancellationMutation(objectId, async () => {
    close();
    await actions.revalidate();
  });
  if (queryLoading || !queryData) {
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "danger",
      "data-test-id": TEST_IDS.Cancel,
      size: "auto",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.SubscriptionCancellationModal.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        style: {
          position: 'relative'
        },
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIAbstractProgress, {
            Component: UINanoProgress,
            maximum: 35
          }), /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "small",
            "data-test-id": "cancellation-modal:loading",
            minHeight: 100,
            layout: "centered",
            grow: true,
            showLabel: true,
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.SubscriptionCancellationModal.loadingMessage"
            })
          })]
        })
      })]
    });
  }
  const hasUserError = ((_submitData$response$ = submitData === null || submitData === void 0 || (_submitData$response = submitData.response) === null || _submitData$response === void 0 || (_submitData$response = _submitData$response.userErrors) === null || _submitData$response === void 0 ? void 0 : _submitData$response.length) !== null && _submitData$response$ !== void 0 ? _submitData$response$ : 0) > 0;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    "data-test-id": TEST_IDS.Cancel,
    size: "auto",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: close
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.SubscriptionCancellationModal.description"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.SubscriptionCancellationModal.body_jsx",
            options: linkOptions,
            elements: linkElement
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        disabled: !!submitError,
        loading: submitLoading,
        onClick: () => {
          onSubmit().catch(e => handleError(e));
        },
        failed: !!submitError || hasUserError,
        use: "danger",
        "data-test-id": `${TEST_IDS.Cancel}:submit`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.confirmCancel"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: close,
        "data-test-id": `${TEST_IDS.Cancel}:cancel`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "common.cancel"
        })
      })]
    })]
  });
}